import { render, staticRenderFns } from "./ModalFormGroup.vue?vue&type=template&id=04886874"
import script from "./ModalFormGroup.vue?vue&type=script&lang=js"
export * from "./ModalFormGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports